import moment from 'moment';
import { useEffect, useState } from 'react';

import { ButtonBack } from '../../components/ButtonBack';
import { Card } from '../../components/Card';
import { LeadSteps } from '../../components/LeadSteps';
import { List, ListItem } from '../../components/List';
import { Loading } from '../../components/Loading';

import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';

import { ILeads } from './Interfaces';

import step1Image from '../../assets/images/step-1.png';
import step2Image from '../../assets/images/step-2.png';
import step3Image from '../../assets/images/step-3.png';
import step4Image from '../../assets/images/step-4.png';
import stepCanceled from '../../assets/images/step-cancelado.png';

import { HelmetComponent } from '../../components/Helmet';
import { Button } from '../../components/Button';
import { Input } from '../../components/forms/Input';

export function MyIndications() {
  const { client, player, getClientByUrl } = useAuth();
  const [leads, setLeads] = useState<Array<ILeads>>();
  const [leadSearch, setLeadSearch] = useState<string>('');
  const [loadingLeads, setLoadingLeads] = useState<boolean>(true);
  const [loadingCustomLeads, setLoadingCustomLeads] = useState<boolean>(true);
  const [stepsListsImagesAdaptative, setStepsListsImagesAdaptative] =
    useState<Array<string>>();
  const [percentGoal, setPercentGoal] = useState<number>(0);
  const [isShowMore, setIsShowMore] = useState<boolean>(false);
  const [isMdClient, setisMdClient] = useState<boolean>(false);

  const stepsListImages: Array<string> = [];

  useEffect(() => {
    if (client.steps.length === 2) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step4Image;
    }

    if (client.steps.length === 3) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step2Image;
      stepsListImages[2] = step4Image;
    }

    if (client.steps.length === 4) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step2Image;
      stepsListImages[2] = step3Image;
      stepsListImages[3] = step4Image;
    }

    setStepsListsImagesAdaptative(stepsListImages);

    if (client.clientUrl === 'tenda') {
      setLoadingCustomLeads(false);
      setLoadingLeads(false);
    }

    if (client && client.clientUrl === 'md') {
      setisMdClient(!isMdClient);
    }

    if (client && client.clientUrl === 'cury') {
      setisMdClient(!isMdClient);
    }

    getMyIndications();
    if (
      client &&
      client.scaleEnable === 'true' &&
      client.mgmVinculated &&
      client.mgmVinculated === 'true' &&
      player &&
      player.regional === 'sim'
    ) {
      getMonthlyGoal();
    }

    getClientByUrl();
  }, []);

  const getMyIndications = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getMyIndications',
        userType: 'player',
        statusFilter: '',
        client: client,
        isInfluencer: null,
      };

      if (
        client &&
        client.isTeamCompetition &&
        client.isTeamCompetition === 'true' &&
        player &&
        player.influencer
      ) {
        parameters.isInfluencer = player.influencer;
      }

      const { data } = await api.post('/search', parameters);
      if (data.success) {
        setLeads(data.data);
      }
      setLoadingLeads(false);
      setLoadingCustomLeads(false);
    } catch (error) {
      console.log('getMyIndications eror: ', error);
      setLoadingLeads(false);
      setLoadingCustomLeads(false);
    }
  };

  const getMonthlyGoal = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getMonthlyGoal',
        userType: 'player',
        clientId: client && client.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        setPercentGoal(data.data);
      }
    } catch (error) {
      console.log('getMonthlyGoal error: ', error);
    }
  };

  const filteredLeads = leads?.filter((lead) =>
    lead.name.toLowerCase().includes(leadSearch?.toLowerCase())
  );

  if (loadingLeads || loadingCustomLeads) {
    return <Loading />;
  }

  const getMonth = new Date(client.scaleStartDateEpoch).toLocaleString(
    'pt-BR',
    { month: 'long' }
  );
  const getYear = new Date(client.scaleStartDateEpoch).getFullYear();

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Meus Indicados'}
      />
      <div className="container">
        <div className="row">
          <div className="my-3">
            <ButtonBack title="Meus indicados" />
          </div>
        </div>
        <div className="row">
          <div
            className={`${
              client &&
              client.scaleEnable === 'true' &&
              client.mgmVinculated &&
              client.mgmVinculated === 'true' &&
              player &&
              player.regional === 'sim'
                ? 'col-sm-12 col-md-8'
                : 'col-sm-12'
            }`}
          >
            <div className="mb-3">
              <Card>
                <List>
                  <ListItem
                    content="Total de indicações"
                    icon={'format_list_bulleted'}
                    secondaryContent={
                      leads && leads.length > 1
                        ? `${leads.length} indicados`
                        : `${leads?.length} indicado`
                    }
                  />
                </List>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: 'auto',
                  }}
                >
                  <div
                    style={{
                      fontSize: '16px',
                      fontWeight: '500',
                      marginBottom: '10px',
                      marginTop: '10px',
                    }}
                  >
                    Status da indicação
                  </div>
                  <div style={{ display: 'flex' }}>
                    {stepsListsImagesAdaptative.map((step, index) => {
                      return (
                        <div
                          style={{
                            display: 'grid',
                            justifyItems: 'center',
                            paddingLeft: '30px',
                          }}
                          key={index}
                        >
                          <img
                            src={stepsListsImagesAdaptative[index]}
                            alt="stepIcon"
                            style={{ width: '40px' }}
                          />
                          <div
                            style={{
                              marginTop: '10px',
                              fontSize: '13px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              width: '100%',
                            }}
                          >
                            {client.steps[index].name}
                          </div>
                        </div>
                      );
                    })}
                    <div
                      style={{ justifyItems: 'center', paddingLeft: '30px' }}
                    >
                      <img
                        src={stepCanceled}
                        alt="stepIcon"
                        style={{ width: '40px' }}
                      />
                      <div
                        style={{
                          marginTop: '10px',
                          fontSize: '13px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        Cancelado
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div className="col-12 col-sm-12 col-md-12 mb-12 mb-3">
              <label>Pesquise pelo nome do indicado</label>
              <Input
                name="Indicados"
                placeholder="Nome do indicado"
                type="text"
                onChange={(e) => {
                  setLeadSearch(e.target.value);
                }}
              />
            </div>
            <Card>
              <List>
                {isShowMore ? (
                  <>
                    {filteredLeads?.length > 0 &&
                      filteredLeads.map((lead, index) => {
                        return (
                          <ListItem
                            key={index}
                            image={
                              lead.canceled
                                ? stepCanceled
                                : stepsListsImagesAdaptative &&
                                  stepsListsImagesAdaptative[lead.status]
                            }
                            content={`${lead.name.split(' ')[0]} ${
                              lead.name.split(' ')[1]
                                ? lead.name.split(' ')[1][0]
                                : ''
                            }`}
                            secondaryContent={moment(lead.createdAt).format(
                              'DD/MM/YYYY'
                            )}
                            expansible={true}
                            contentExpansible={
                              <LeadSteps
                                contact={
                                  client &&
                                  client.phoneEnable === 'true' &&
                                  player &&
                                  player.regional &&
                                  player.regional === 'sim'
                                    ? lead.phone
                                    : false
                                }
                                product={lead?.action?.actionTitle || ''}
                                registerDate={moment(lead.createdAt).format(
                                  'DD/MM/YYYY'
                                )}
                                stepsNames={client.steps}
                                step={lead.status}
                                description={lead.description}
                                isCanceled={lead.canceled}
                                businessName={
                                  lead.businessName ? lead.businessName : ''
                                }
                                lead={lead}
                                client={client}
                              />
                            }
                          />
                        );
                      })}
                    <div className="mt-4">
                      <div className="d-flex justify-content-center">
                        <Button
                          text="Ver menos"
                          color="flat"
                          icon="add"
                          onClick={() => {
                            setIsShowMore(false);
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {filteredLeads?.length > 0 &&
                      filteredLeads.slice(0, 10).map((lead, index) => {
                        return (
                          <ListItem
                            key={index}
                            image={
                              lead.canceled
                                ? stepCanceled
                                : stepsListsImagesAdaptative &&
                                  stepsListsImagesAdaptative[lead.status]
                            }
                            content={`${lead.name.split(' ')[0]} ${
                              lead.name.split(' ')[1]
                                ? lead.name.split(' ')[1][0]
                                : ''
                            }`}
                            secondaryContent={moment(lead.createdAt).format(
                              'DD/MM/YYYY'
                            )}
                            expansible={true}
                            contentExpansible={
                              <LeadSteps
                                contact={
                                  client &&
                                  client.phoneEnable === 'true' &&
                                  player &&
                                  player.regional &&
                                  player.regional === 'sim'
                                    ? lead.phone
                                    : false
                                }
                                product={lead?.action?.actionTitle || ''}
                                registerDate={moment(lead.createdAt).format(
                                  'DD/MM/YYYY'
                                )}
                                stepsNames={client.steps}
                                step={lead.status}
                                description={lead.description}
                                isCanceled={lead.canceled}
                                businessName={
                                  lead.businessName ? lead.businessName : ''
                                }
                                lead={lead}
                                client={client}
                              />
                            }
                          />
                        );
                      })}
                    <div className="mt-4">
                      <div className="d-flex justify-content-center">
                        <Button
                          text="Ver mais"
                          color="flat"
                          icon="add"
                          onClick={() => {
                            setIsShowMore(true);
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}

                {leads?.length > 0 && filteredLeads?.length === 0 && (
                  <ListItem
                    icon="hourglass_empty"
                    content="Nenhum lead encontrado"
                  />
                )}
                {leads?.length === 0 && (
                  <ListItem
                    icon="hourglass_empty"
                    content="Você ainda não tem indicados"
                  />
                )}
              </List>
            </Card>
          </div>
          <div
            className={`${
              client &&
              client.scaleEnable === 'true' &&
              client.mgmVinculated &&
              client.mgmVinculated === 'true' &&
              player &&
              player.regional === 'sim'
                ? 'col-sm-12 col-md-4'
                : 'd-none'
            }`}
          >
            {client &&
              client.mgmVinculated &&
              client.mgmVinculated === 'true' &&
              player &&
              player.regional === 'sim' &&
              !isMdClient && (
                <Card>
                  <p className="m-0 fw-semibold fs-4">Meta</p>
                  {getMonth && getYear ? (
                    <p className="text-capitalize">
                      {getMonth}, {getYear}
                    </p>
                  ) : (
                    <p className="text-capitalize">Não definido</p>
                  )}
                  <div className="mt-3">
                    <div className="row">
                      <div className="col">
                        <div className="single-chart">
                          <svg
                            viewBox="0 0 36 36"
                            className="circular-chart primary"
                          >
                            <path
                              className="circle-bg"
                              d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                            />
                            <path
                              className="circle"
                              strokeDasharray={`${percentGoal}, 100`}
                              d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                            />
                            <text
                              x="50%"
                              y="17"
                              style={{
                                dominantBaseline: 'middle',
                                textAnchor: 'middle',
                              }}
                              className="percentage"
                            >
                              {Math.round(percentGoal)}
                            </text>
                            <text
                              x="50%"
                              y="24"
                              style={{
                                dominantBaseline: 'middle',
                                textAnchor: 'middle',
                              }}
                              className="percentage-symbol"
                            >
                              por cento
                            </text>
                          </svg>
                        </div>
                      </div>
                      <div className="col">
                        <div className="d-flex align-items-center flex-column mt-4">
                          <p className="m-0 tiny-text">Meta do mês</p>
                          <p className="fs-1 m-0 color-text-primary">
                            {' '}
                            {client.scalePreset}
                          </p>
                          <p className="m-0 tiny-text">vendas</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{client.scaleDescription}</p>
                  </div>
                </Card>
              )}
          </div>
        </div>
      </div>
    </>
  );
}
